module.exports = __webpack_public_path__ + "img/2_04.4ed52b17.jpg";